<div class="fc-product-detail-product-price-wrapper">
    <div class="fc-product-detail-product-price" fc-skeleton>
        <span class="fc-product-detail-product-price-label fc-product-detail-product-price-label-pp fcp-text-body-m">
            {{ 'ORDER.PRODUCT_DETAILS.PP' | translate }}
        </span>

        <div *ngIf="article?.hasDiscountedPurchasePrice">
            <span
                [ngClass]="{ 'fc-product-detail-product-price-value-highlighted': article.hasDiscountedPurchasePrice }"
                class="fcp-text-body-m fc-product-detail-product-price-value"
                data-e2e-hook="pdp-discounted-purchase-price"
            >
                {{ article?.formattedPrice?.discountedPurchasePrice }}
            </span>
        </div>
        <span
            [ngClass]="{ 'fc-product-detail-product-price-value-replaced': article.hasDiscountedPurchasePrice }"
            class="fcp-text-body-m fc-product-detail-product-price-value"
            *ngIf="article?.hasDiscountedPurchasePrice"
            data-e2e-hook="pdp-purchase-price"
        >
            {{ article.formattedPrice.purchasePrice }}
        </span>

        <span
            class="fcp-text-body-m fc-product-detail-product-price-value"
            *ngIf="!article?.hasDiscountedPurchasePrice"
            data-e2e-hook="pdp-purchase-price-when-no-discounted-purchase-price"
        >
            {{ article?.formattedPrice?.purchasePrice }}
        </span>
    </div>

    <div class="fc-product-detail-product-price" fc-skeleton>
        <span class="fc-product-detail-product-price-label">{{ 'ORDER.PRODUCT_DETAILS.RRP' | translate }}</span>
        <span class="fcp-text-body-m fc-product-detail-product-price-value" data-e2e-hook="pdp-retail-price">
            {{ article?.formattedPrice?.recommendedRetailPrice }}
        </span>
    </div>
</div>
